var exports = {
  "P": "xcc377c0b--0e97a9--observer-wrapper",
};

module.exports = exports;
